//import React, {ChangeEvent, useState, useEffect} from "react";
import React, { useState, useEffect } from "react";
import * as $ from "jquery";
import './planner.scss';
import { Language } from "../../Utils/Language";
import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import PlannerTask from "./plannertask";
import CalView from "../CalView/calview";
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import {
    Dropdown,
    IDropdownOption
} from 'office-ui-fabric-react/lib/Dropdown';
import { Helper } from "../../Utils/Helper";
import { DateHelper } from "../../Helpers/DateHelper";
import { DefaultButton } from "office-ui-fabric-react";


interface Props {
    PlannerTask;
    culture;
    myPlanList;
    Users;
    Loadpic;
    UpdateData;
    UserEmail;
    Language;
    Header;
    Phrases;
    ReloadPlannerTasks;
    Progress;
    ThisWeekStartDate;
    ThisWeekEndDate;
    NextWeekStartDate
    NextWeekEndDate
    GraphHeader;
    GetPlannerTaks;
    changeplan;
    HomeAction;
    APIHeader;
    APIServiceurl;
    CurrentUser;
    TriggerReloadPlannerTasks: boolean;
    RefreshCRMData;
}

const PlannerDashboard: React.FC<Props> = (props) => {
    let viewthisweek = 'thisweek';
    let viewnextweek = 'nextweek';
    let viewmatrix = 'matarix';
    let viewlate = 'latetasks';
    let viewnodue = 'noduedate';
    let CurrentUserList = [];

    const [requestedplanlist, SetRequestedPlanList] = useState<Array<string>>([]);
    const [view, setview] = useState<string>(viewthisweek);
    const [selectedStatus, SetSelectedStatus] = useState<any>();
    const [selectedPriorityItems, SetSelectedPriorityItems] = useState<Array<string>>([]);
    const [selectedplanItems, SetSelectedPlanItems] = useState<Array<string>>([]);
    const [selectedUserItems, SetSelectedUserItems] = useState<Array<string>>([]);
    const [selectedCreatedUserItems, SetselectedCreatedUserItems] = useState<Array<string>>([]);
    const [selectedAssignedByUserItems, SetselectedAssignedByUserItems] = useState<Array<string>>([]);
    const [filterchanged, SetFilterChanged] = useState<Date>(null);
    const [ismytasks, SetIsMyTask] = useState<boolean>(true);
    const [_plannerTask, setPlannerTask] = useState({ Today: [], ThisWeek: [], NextWeek: [], Late: [], WithoutdueDate: [] });

    useEffect(() => {

    }, [props, filterchanged]);

    const RenderThisWeek = () => {

        let tasks = GetFilteredTasks(ismytasks ? props.PlannerTask.ThisWeek : _plannerTask.ThisWeek);

        return (
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <CalView
                        crmmeetings={[]}
                        ssos={[]}
                        todos={[]}
                        plannertasks={tasks}
                        outlookevents={[]}
                        week={1}
                        startdate={props.ThisWeekStartDate}
                        Header={props.GraphHeader}
                        Users={props.Users}
                        Loadpic={props.Loadpic}
                        PlannerUpdateData={UpdateDataAfterCreateEditSuccess}
                        ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                        Phases={[]}
                        Probability={[]}
                        SSOUpdateMethod={null}
                        LogTitle={''}
                        extpropid={''}
                        CreateOrCancelPreperationEvent={null}
                        UpdateEvent={null}
                        AcceptEvent={null}
                        Getcrmdataforrecent={null}
                        PrepareContactCRMReportUI={null}
                        PrepareContactCRMSSOUI={null}
                        GetCRMContactCompany={null}
                        GetContactRelatedMails={null}
                        GetOutlookemailAttachments={null}
                        CRMMeetingUpdateMethod={null}
                        UpdateToDoItem={null}
                        UpdatePlannerTask={null}
                        UserEmail={props.UserEmail}
                        Language={props.culture}
                        InsideCRM={false}
                        CRMURL={''}
                        eventphrases={null}
                        plannertaskphrases={props.Phrases}
                        SSOPhrases={[]}
                        TODOPhrases={[]}
                        MeetingReportPhrases={[]}
                        Progress={props.Progress}
                        OverAllFilter={0}
                        showweekend={true}
                        meetingcontacts={[]}
                        ssocontacts={[]}

                        flagedemailPhrases={[]}
                        flaggedemailupdate={[]}
                        flaggedemails={[]}
                        taskfromflagemail={[]}
                        usertimezone={''}

                        MySetting={null}
                        MSListUpdateMethod={null}
                        MSListUsers={null}
                        MSListItems={null}

                        APIHeader={props.APIHeader}
                        APIServiceurl={props.APIServiceurl}

                        EmptyMessage="Looks like you have a slow week. You have no activities this week"
                        CurrentUser={props.CurrentUser}

                        RefreshCRMData={props.RefreshCRMData}
                    />
                </div>
            </div>
        );
    }
    const RenderNextWeek = () => {
        let tasks = GetFilteredTasks(ismytasks ? props.PlannerTask.NextWeek : _plannerTask.NextWeek);
        return (
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <CalView
                        crmmeetings={[]}
                        ssos={[]}
                        todos={[]}
                        plannertasks={tasks}
                        outlookevents={[]}
                        week={1}
                        startdate={props.NextWeekStartDate}
                        Header={props.GraphHeader}
                        Users={props.Users}
                        Loadpic={props.Loadpic}
                        PlannerUpdateData={UpdateDataAfterCreateEditSuccess}
                        ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                        Phases={[]}
                        Probability={[]}
                        SSOUpdateMethod={null}
                        LogTitle={''}
                        extpropid={''}
                        CreateOrCancelPreperationEvent={null}
                        UpdateEvent={null}
                        AcceptEvent={null}
                        Getcrmdataforrecent={null}
                        PrepareContactCRMReportUI={null}
                        PrepareContactCRMSSOUI={null}
                        GetCRMContactCompany={null}
                        GetContactRelatedMails={null}
                        GetOutlookemailAttachments={null}
                        CRMMeetingUpdateMethod={null}
                        UpdateToDoItem={null}
                        UpdatePlannerTask={null}
                        UserEmail={props.UserEmail}
                        Language={props.culture}
                        InsideCRM={false}
                        CRMURL={''}
                        eventphrases={null}
                        plannertaskphrases={props.Phrases}
                        SSOPhrases={[]}
                        TODOPhrases={[]}
                        MeetingReportPhrases={[]}
                        Progress={props.Progress}
                        OverAllFilter={0}
                        showweekend={true}
                        meetingcontacts={[]}
                        ssocontacts={[]}

                        flagedemailPhrases={[]}
                        flaggedemailupdate={[]}
                        flaggedemails={[]}
                        taskfromflagemail={[]}
                        usertimezone={''}

                        MySetting={null}
                        MSListUpdateMethod={null}
                        MSListUsers={null}
                        MSListItems={null}

                        APIHeader={props.APIHeader}
                        APIServiceurl={props.APIServiceurl}

                        EmptyMessage="Looks like you have a slow next week. You have no activities next week"
                        CurrentUser={props.CurrentUser}

                        RefreshCRMData={props.RefreshCRMData}
                    />
                </div>
            </div>
        );
    }
    const Rendermatrix = () => {
        let AllTasks = [];
        if (ismytasks) {
            AllTasks = [].concat(props.PlannerTask.NextWeek, props.PlannerTask.ThisWeek, props.PlannerTask.Late);
        } else {
            AllTasks = [].concat(_plannerTask.NextWeek, _plannerTask.ThisWeek, _plannerTask.Late);

        }

        AllTasks = GetFilteredTasks(AllTasks);


        let urgentlist = AllTasks.filter((t) => { return [0, 1].indexOf(t.priority) >= 0 });
        let importantlist = AllTasks.filter((t) => { return [2, 3, 4].indexOf(t.priority) >= 0 });
        let mediumlist = AllTasks.filter((t) => { return [5, 6, 7].indexOf(t.priority) >= 0 });
        let lowlist = AllTasks.filter((t) => { return [8, 9, 10].indexOf(t.priority) >= 0 });

        let Preparematrixitem = (currentlist) => {
            return (
                <React.Fragment>
                    {focusActions}
                    {currentlist.map((obj, index) => {
                        let keyval = 'Plannerlist_' + obj.id;
                        return (
                            <div className="ms-Grid-col ms-sm6 ms-lg4 webpartitem">
                                <PlannerTask
                                    data={obj}
                                    key={keyval}
                                    // key={obj.id} 
                                    Users={props.Users}
                                    Loadpic={props.Loadpic}
                                    UpdateData={UpdateDataAfterCreateEditSuccess}
                                    UserEmail={props.UserEmail}
                                    Language={props.Language}
                                    Header={props.Header}
                                    Phrases={props.Phrases}
                                    ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                                    Progress={props.Progress}
                                    SMView={true}
                                    APIHeader={props.APIHeader}
                                    APIServiceurl={props.APIServiceurl}
                                    CurrentUser={props.CurrentUser}
                                />
                            </div>

                        );
                    })}
                </React.Fragment>
            )

        };

        let focusActions = (
            <React.Fragment>
                <i className="ms-Icon ms-Icon--ScaleUp focusaction" title="maximize" onClick={(event) => {
                    $(event.currentTarget).parent().addClass('plannermatrixFocused');
                }} />
                <i className="ms-Icon ms-Icon--StatusErrorFull focusclose" title="minimize" onClick={(event) => {
                    $(event.currentTarget).parent().removeClass('plannermatrixFocused');
                }} />
            </React.Fragment>
        )
        return (
            <React.Fragment>
                <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ overflow: 'auto' }}>
                    <div className="matrixcontainer">
                        <div className="quadrantleftbox" id="dvleftbox">
                            <div className="innerbox"><span>{Language.GetLanguageValue(props.culture, 'matrixheadingimportant')}</span></div>
                            <div className="innerbox"><span>{Language.GetLanguageValue(props.culture, 'matrixheadingnotimportant')}</span></div>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                        <div className="quadrantcontainer" id="dvquadrantcontainer">
                            <div className="ms-Grid-row" style={{ marginBottom: '6px' }}>
                                <div className="ms-Grid-col ms-sm6 ms-lg6 matrixheading">
                                    {Language.GetLanguageValue(props.culture, 'matrixheadingurgent')}
                                </div>
                                <div className="ms-Grid-col ms-sm6 ms-lg6 matrixheading">
                                    {Language.GetLanguageValue(props.culture, 'matrixheadingnoturgent')}
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div id="dvurgent" className="ms-Grid-col ms-sm6 ms-lg6 plannermatrix quurgent">
                                    {urgentlist.length > 0 ? Preparematrixitem(urgentlist) : (<span className="emptymessageblock">There is no urgent task.</span>)}

                                </div>
                                <div id="dvimportant" className="ms-Grid-col ms-sm6 ms-lg6 plannermatrix quimportant">
                                    {importantlist.length > 0 ? Preparematrixitem(importantlist) : (<span className="emptymessageblock">There is no important task.</span>)}

                                </div>
                                <div id="dvmedium" className="ms-Grid-col ms-sm6 ms-lg6 plannermatrix qumedium">
                                    {mediumlist.length ? Preparematrixitem(mediumlist) : (<span className="emptymessageblock">There is no medium task.</span>)}
                                </div>
                                <div id="dvlow" className="ms-Grid-col ms-sm6 ms-lg6 plannermatrix qulow">
                                    {lowlist.length > 0 ? Preparematrixitem(lowlist) : (<span className="emptymessageblock">There is no low task.</span>)}

                                </div>
                            </div>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                        <div style={{ clear: 'both' }}></div>
                    </div>
                </div>




            </React.Fragment>
        );
    }

    const RenderLate = () => {
        let tasks = GetFilteredTasks(ismytasks ? props.PlannerTask.Late : _plannerTask.Late);
        let temp = tasks.filter((t: CPlannerTask) => { return t.col < 0 });
        tasks = temp;
        //
        let lessthan1week = [];
        let lessthan2week = [];
        let morethan2week = [];

        let from = new Date();

        {
            tasks.map((obj, index) => {
                let dueDate = new Date(obj.dueDateTime);
                let dif = DateHelper.GetDateDiffInDays(dueDate, from);
                let keyval = 'Plannerlist_' + obj.id;
                if (dif <= 7) {
                    lessthan1week.push(<PlannerTask
                        data={obj}
                        key={keyval}
                        // key={obj.id} 
                        Users={props.Users}
                        Loadpic={props.Loadpic}
                        UpdateData={UpdateDataAfterCreateEditSuccess}
                        UserEmail={props.UserEmail}
                        Language={props.Language}
                        Header={props.Header}
                        Phrases={props.Phrases}
                        ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                        Progress={props.Progress}
                        APIHeader={props.APIHeader}
                        APIServiceurl={props.APIServiceurl}
                        CurrentUser={props.CurrentUser}
                    />);
                } else if (dif <= 14) {
                    lessthan2week.push(<PlannerTask
                        data={obj}
                        key={keyval}
                        // key={obj.id} 
                        Users={props.Users}
                        Loadpic={props.Loadpic}
                        UpdateData={UpdateDataAfterCreateEditSuccess}
                        UserEmail={props.UserEmail}
                        Language={props.Language}
                        Header={props.Header}
                        Phrases={props.Phrases}
                        ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                        Progress={props.Progress}
                        APIHeader={props.APIHeader}
                        APIServiceurl={props.APIServiceurl}
                        CurrentUser={props.CurrentUser}
                    />);
                } else {
                    morethan2week.push(<PlannerTask
                        data={obj}
                        key={keyval}
                        // key={obj.id} 
                        Users={props.Users}
                        Loadpic={props.Loadpic}
                        UpdateData={UpdateDataAfterCreateEditSuccess}
                        UserEmail={props.UserEmail}
                        Language={props.Language}
                        Header={props.Header}
                        Phrases={props.Phrases}
                        ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                        Progress={props.Progress}
                        APIHeader={props.APIHeader}
                        APIServiceurl={props.APIServiceurl}
                        CurrentUser={props.CurrentUser}
                    />);
                }

            })
        }
        return (
            <React.Fragment>
                {/*  <div className="ms-Grid-row" style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4">Week late</div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4">Two Weeks late</div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4">More late</div>

                </div> */}

                <div className="ms-Grid-row">
                    {tasks.length > 0 ? (
                        <React.Fragment>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <div className="lateheading">Week late</div>
                                {lessthan1week}
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <div className="lateheading">Two Weeks late</div>
                                {lessthan2week}</div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <div className="lateheading">More late</div>
                                {morethan2week}</div>
                        </React.Fragment>

                    ) : (<span className="emptymessageblock">There is no late task.</span>)}


                </div>
            </React.Fragment>
        );
    }
    const RenderNoDue = () => {
        let tasks = GetFilteredTasks(ismytasks ? props.PlannerTask.WithoutdueDate : _plannerTask.WithoutdueDate);
        return (<div className="ms-Grid-row">
            {tasks.length > 0 ? tasks.map((obj, index) => {
                let keyval = 'Plannerlist_' + obj.id;
                //let keyval=obj.id;
                return (
                    <div className="ms-Grid-col ms-sm12 ms-lg3" key={keyval}>
                        <PlannerTask
                            data={obj}
                            key={keyval}
                            // key={obj.id} 
                            Users={props.Users}
                            Loadpic={props.Loadpic}
                            UpdateData={UpdateDataAfterCreateEditSuccess}
                            UserEmail={props.UserEmail}
                            Language={props.Language}
                            Header={props.Header}
                            Phrases={props.Phrases}
                            ReloadPlannerTasks={ReloadPlannerTasksAfterCreateEditSuccess}
                            Progress={props.Progress}
                            APIHeader={props.APIHeader}
                            APIServiceurl={props.APIServiceurl}
                            CurrentUser={props.CurrentUser}
                        />
                    </div>

                );
            }) : (<span className="emptymessageblock">There is no task without due date.</span>)}
        </div>);
    }
    const RenderTaskFilter = () => {
        return (
            <React.Fragment>
                <ul id="plannerfilters">
                    <li><Dropdown
                        className="filterdropdown"
                        placeholder="Filter by Status"
                        selectedKey={selectedStatus}
                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                            SetSelectedStatus(item.key);
                        }}
                        options={[
                            { key: '', text: 'Filter by Status' },
                            { key: '0', text: props.Phrases.notstarted },
                            { key: '50', text: props.Phrases.inprogress }
                        ]} />
                    </li>
                    {
                        view != viewmatrix && (
                            <li>
                                <Dropdown
                                    className="filterdropdown"
                                    placeholder="Filter by Priority"
                                    selectedKeys={selectedPriorityItems}
                                    onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {

                                        let selectedkey = item.key as string;
                                        if (item.selected) {
                                            selectedPriorityItems.push(selectedkey);

                                        } else {
                                            const currIndex = selectedPriorityItems.indexOf(selectedkey);
                                            if (currIndex > -1) {
                                                selectedPriorityItems.splice(currIndex, 1);
                                            }

                                        }
                                        SetSelectedPriorityItems(selectedPriorityItems);
                                        SetFilterChanged(new Date());
                                    }}
                                    multiSelect
                                    options={[
                                        { key: '0', text: props.Phrases.urgent },//0,1
                                        { key: '1', text: props.Phrases.important },//2,3,4
                                        { key: '2', text: props.Phrases.medium },//5,6,7   
                                        { key: '3', text: props.Phrases.low },//8,9,10               
                                    ]}
                                />
                            </li>

                        )
                    }
                    <li><Dropdown
                        className="filterdropdown"
                        placeholder="Filter by Assignee"
                        //label="User"
                        selectedKeys={selectedUserItems}
                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {

                            let selectedkey = item.key as string;
                            if (item.selected) {
                                selectedUserItems.push(selectedkey);

                            } else {
                                const currIndex = selectedUserItems.indexOf(selectedkey);
                                if (currIndex > -1) {
                                    selectedUserItems.splice(currIndex, 1);
                                }

                            }
                            SetSelectedUserItems(selectedUserItems);
                            SetFilterChanged(new Date());
                        }}
                        multiSelect
                        options={CurrentUserList}
                        styles={{ dropdown: { width: 300 } }}
                        onRenderOption={(option: IDropdownOption): JSX.Element => {
                            let src = option.data && option.data.Image ? option.data.Image : Helper.GetDefaultImage();
                            return (
                                <div className="ellipsistext">
                                    <img src={src} style={{ width: '20px', borderRadius: '50%', margin: '0 3px', float: 'left' }} />
                                    <span>{option.text}</span>
                                </div>
                            );
                        }}
                    /></li>
                    <li><Dropdown
                        className="filterdropdown"
                        placeholder="Filter by Assigned By"
                        //label="User"
                        selectedKeys={selectedAssignedByUserItems}
                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {

                            let selectedkey = item.key as string;
                            if (item.selected) {
                                selectedAssignedByUserItems.push(selectedkey);

                            } else {
                                const currIndex = selectedAssignedByUserItems.indexOf(selectedkey);
                                if (currIndex > -1) {
                                    selectedAssignedByUserItems.splice(currIndex, 1);
                                }

                            }
                            SetselectedAssignedByUserItems(selectedAssignedByUserItems);
                            SetFilterChanged(new Date());
                        }}
                        multiSelect
                        options={CurrentUserList}
                        styles={{ dropdown: { width: 300 } }}
                        onRenderOption={(option: IDropdownOption): JSX.Element => {
                            let src = option.data && option.data.Image ? option.data.Image : Helper.GetDefaultImage();
                            return (
                                <div className="ellipsistext">
                                    <img src={src} style={{ width: '20px', borderRadius: '50%', margin: '0 3px', float: 'left' }} />
                                    <span>{option.text}</span>
                                </div>
                            );
                        }}
                    /></li>
                    <li><Dropdown
                        className="filterdropdown"
                        placeholder="Filter by Creator"
                        //label="User"
                        selectedKeys={selectedCreatedUserItems}
                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {

                            let selectedkey = item.key as string;
                            if (item.selected) {
                                selectedCreatedUserItems.push(selectedkey);

                            } else {
                                const currIndex = selectedCreatedUserItems.indexOf(selectedkey);
                                if (currIndex > -1) {
                                    selectedCreatedUserItems.splice(currIndex, 1);
                                }

                            }
                            SetselectedCreatedUserItems(selectedCreatedUserItems);
                            SetFilterChanged(new Date());
                        }}
                        multiSelect
                        options={CurrentUserList}
                        styles={{ dropdown: { width: 300 } }}
                        onRenderOption={(option: IDropdownOption): JSX.Element => {
                            let src = option.data && option.data.Image ? option.data.Image : Helper.GetDefaultImage();
                            return (
                                <div className="ellipsistext">
                                    <img src={src} style={{ width: '20px', borderRadius: '50%', margin: '0 3px', float: 'left' }} />
                                    <span>{option.text}</span>
                                </div>
                            );
                        }}
                    /></li>
                </ul>
            </React.Fragment>
        );
    }
    const PrepareCurrentUserList = (assignments) => {
        for (var assignedTo in assignments) {
            if (CurrentUserList.findIndex((u) => { return u.key == assignedTo }) < 0) {
                let user = props.Users.find((u) => { return u.id == assignedTo });
                if (user) {
                    //imagepath
                    CurrentUserList.push({
                        key: user.id,
                        text: user.displayName + '(' + user.mail + ')',
                        data: { Image: user.imagepath }
                    });
                }
            }
        }
    }
    const GetFilteredTasks = (tasks: Array<CPlannerTask>) => {

        CurrentUserList = [];
        let newTasks = tasks;
        if (!ismytasks) {
            if (selectedplanItems.length == 0) {
                newTasks = [];
            } else {
                newTasks = newTasks.filter((t) => { return selectedplanItems.indexOf(t.planId) >= 0 });
            }
        }
        if (selectedStatus) {
            if (selectedStatus == 0) {
                newTasks = newTasks.filter((t) => { return t.percentComplete == 0 });
            } else {
                newTasks = newTasks.filter((t) => { return t.percentComplete != 0 });
            }
        }
        if (selectedPriorityItems.length > 0 && view != viewmatrix) {
            let priorityno = {
                '0': [0, 1],
                '1': [2, 3, 4],
                '2': [5, 6, 7],
                '3': [8, 9, 10]
            }
            let priorityLists = [];
            selectedPriorityItems.forEach(element => {
                priorityLists = priorityLists.concat(priorityno[element]);
            });
            // newselections=[...selectedPriorityItems,priorityno[selectedkey]];
            newTasks = newTasks.filter((t) => { return priorityLists.indexOf(t.priority) >= 0 });
        }
        newTasks.forEach((t) => {
            PrepareCurrentUserList(t.assignments);
        });
        Helper.SortList(CurrentUserList, 'text', true, false);

        if (selectedUserItems.length > 0) {
            newTasks = newTasks.filter((t) => {
                let found = false;
                selectedUserItems.forEach(uid => {

                    t.assignments[uid] && (found = true);
                });
                return found;
            });

        }

        if (selectedCreatedUserItems.length > 0) {
            newTasks = newTasks.filter((t) => {
                let found = false;
                selectedCreatedUserItems.forEach(uid => {

                    if (t.createdBy && t.createdBy.user && t.createdBy.user.id == uid) {
                        found = true;
                    }
                });
                return found;
            });

        }

        if (selectedAssignedByUserItems.length > 0) {
            newTasks = newTasks.filter((t) => {
                let found = false;
                selectedAssignedByUserItems.forEach(uid => {

                    Object.keys(t.assignments).map((assignedTo) => {
                        if (t.assignments[assignedTo].assignedBy && t.assignments[assignedTo].assignedBy.user && t.assignments[assignedTo].assignedBy.user.id == uid) {
                            found = true;
                        }
                    });
                });
                return found;
            });

        }
        Helper.SortList(newTasks, 'dueDateTime', false, true);
        return newTasks;
    }
    const ReloadPlannerTasksAfterCreateEditSuccess = (coll: any, planyId: any) => {

        if (ismytasks) {
            props.ReloadPlannerTasks(coll, undefined);
            return;
        };

        setPlannerTask({ Today: [], ThisWeek: [], NextWeek: [], Late: [], WithoutdueDate: [] });
        selectedplanItems.forEach(function (pid) {
            props.ReloadPlannerTasks(coll, pid, function (result: any) {
                if (result != null) {

                    const updatedThisWeek = _plannerTask.ThisWeek.map((item) => {
                        const item2 = result.ThisWeek.find(i2 => i2.id == item.id);
                        if (!item2) {
                            if (item.planId == pid) {
                                return null;
                            } else {
                                return item;
                            }
                        }
                        return item2;
                    }).filter(fi => { return fi; });

                    const updatedToday = _plannerTask.Today.map((item) => {
                        const item2 = result.Today.find(i2 => i2.id == item.id);
                        if (!item2) {
                            if (item.planId == pid) {
                                return null;
                            } else {
                                return item;
                            }
                        }
                        return item2;
                    }).filter(fi => { return fi; });

                    const updatedNextWeek = _plannerTask.NextWeek.map((item) => {
                        const item2 = result.NextWeek.find(i2 => i2.id == item.id);
                        if (!item2) {
                            if (item.planId == pid) {
                                return null;
                            } else {
                                return item;
                            }
                        }
                        return item2;
                    }).filter(fi => { return fi; });

                    const updatedLate = _plannerTask.Late.map((item) => {
                        const item2 = result.Late.find(i2 => i2.id == item.id);
                        if (!item2) {
                            if (item.planId == pid) {
                                return null;
                            } else {
                                return item;
                            }
                        }
                        return item2;
                    }).filter(fi => { return fi; });

                    const updatedWithoutdueDate = _plannerTask.WithoutdueDate.map((item) => {
                        const item2 = result.WithoutdueDate.find(i2 => i2.id == item.id);
                        if (!item2) {
                            if (item.planId == pid) {
                                return null;
                            } else {
                                return item;
                            }
                        }
                        return item2;
                    }).filter(fi => { return fi; });

                    setPlannerTask({
                        Today: updatedToday,
                        ThisWeek: updatedThisWeek,
                        NextWeek: updatedNextWeek,
                        Late: updatedLate,
                        WithoutdueDate: updatedWithoutdueDate,
                    });
                }
            });
        });
    }
    const UpdateDataAfterCreateEditSuccess = (ID, task, etag, col, isbeta) => {
        if (ismytasks) {
            props.UpdateData(ID, task, etag, col, isbeta);
            return;
        }

        props.UpdateData(ID, task, etag, col, isbeta, function () {
            ReloadPlannerTasksAfterCreateEditSuccess(col, undefined);
        });
    }

    let Renderdata = view == viewthisweek ? RenderThisWeek() :
        view == viewnextweek ? RenderNextWeek() :
            view == viewlate ? RenderLate() : view == viewnodue ? RenderNoDue() : Rendermatrix();
    let planlistfordropdown = props.myPlanList.map((obj, index) => {
        return { key: obj.id, text: obj.title }
    });
    Helper.SortList(planlistfordropdown, 'text', true, false);
    return (
        <div className="Planner">
            <div className={Helper.IsMobileScreen() ? "ms-Grid-row topactions d-flex-row-reverse" : "ms-Grid-row topactions d-flex-row-reverse"} >
                <div className="togglecontainer d-flex-row-reverse align-items-center">
                    <Toggle className="pull-right" label="" onText="My Task" offText="Plan Tasks"
                        onChange={(ev: React.MouseEvent<HTMLElement>, checked: boolean) => {
                            SetIsMyTask(checked);
                            if (checked) {
                                ReloadPlannerTasksAfterCreateEditSuccess(undefined, undefined);
                            }else{
                                setPlannerTask({ Today: [], ThisWeek: [], NextWeek: [], Late: [], WithoutdueDate: [] });
                                selectedplanItems.length = 0;
                                requestedplanlist.length = 0;
                                SetSelectedPlanItems(selectedplanItems);
                                SetRequestedPlanList(requestedplanlist);
                            }
                        }}
                        defaultChecked={ismytasks} />
                    { }
                    {ismytasks == false && (
                        <div className="d-flex-row-reverse align-items-center">
                            <Dropdown
                                style={{ textAlign: 'left' }}
                                className="pull-right plandropdown"
                                placeholder="Select plan"
                                onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                                    let planid = item.key as string;
                                    if (item.selected && requestedplanlist.indexOf(planid) < 0) {
                                        requestedplanlist.push(planid);
                                        SetRequestedPlanList(requestedplanlist);
                                        props.changeplan(null, planid, (newplantasks) => {
                                            if (newplantasks != null) {
                                                setPlannerTask({
                                                    Today: _plannerTask.Today.concat(newplantasks.Today),
                                                    ThisWeek: _plannerTask.ThisWeek.concat(newplantasks.ThisWeek),
                                                    NextWeek: _plannerTask.NextWeek.concat(newplantasks.NextWeek),
                                                    Late: _plannerTask.Late.concat(newplantasks.Late),
                                                    WithoutdueDate: _plannerTask.WithoutdueDate.concat(newplantasks.WithoutdueDate),
                                                });
                                                SetFilterChanged(new Date());
                                            }
                                        })
                                    }

                                    if (item.selected) {
                                        selectedplanItems.push(planid);

                                    } else {
                                        const currIndex = selectedplanItems.indexOf(planid);
                                        if (currIndex > -1) {
                                            selectedplanItems.splice(currIndex, 1);
                                        }

                                    }
                                    SetSelectedPlanItems(selectedplanItems);
                                    SetFilterChanged(new Date());
                                }}
                                multiSelect
                                options={planlistfordropdown}
                                styles={{ dropdown: { width: 300 } }}
                            />
                            <DefaultButton onClick={() => { ReloadPlannerTasksAfterCreateEditSuccess(undefined, undefined)}} text={Language.GetLanguageValue(props.culture, "RefreshDashboard")} allowDisabledFocus />
                        </div>
                    )}

                    <div style={{ clear: 'both' }}></div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg12 forioscss">
                    <ul>
                        <li>
                            <button
                                key="plannerdashboard"
                                onClick={props.HomeAction}
                                className="viewswitchbtn weekaction homeaction"
                            >
                                <i className="ms-Icon ms-Icon--HomeSolid"></i>
                                {Language.GetLanguageValue(props.culture, "Home")}
                            </button>
                        </li>
                        <li><button className={view == viewthisweek ? "viewswitchbtn weekaction viewaction viewactionselected" : "viewswitchbtn weekaction viewaction"}
                            onClick={() => {
                                view != viewthisweek && (setview(viewthisweek));
                            }}>{Language.GetLanguageValue(props.culture, "thisweek")}</button></li>
                        <li><button className={view == viewnextweek ? "viewswitchbtn weekaction viewaction viewactionselected" : "viewswitchbtn weekaction viewaction"}
                            onClick={() => {
                                view != viewnextweek && (setview(viewnextweek));
                            }}>{Language.GetLanguageValue(props.culture, "nextweek")}</button></li>
                        <li><button className={view == viewlate ? "viewswitchbtn weekaction viewaction viewactionselected" : "viewswitchbtn weekaction viewaction"}
                            onClick={() => {
                                view != viewlate && (setview(viewlate));
                            }}>{Language.GetLanguageValue(props.culture, "Late")}</button></li>
                        <li><button className={view == viewnodue ? "viewswitchbtn weekaction viewaction viewactionselected" : "viewswitchbtn weekaction viewaction"}
                            onClick={() => {
                                view != viewnodue && (setview(viewnodue));
                            }}>{Language.GetLanguageValue(props.culture, "noduedate")}</button></li>
                        <li> <button className={view == viewmatrix ? "viewswitchbtn weekaction viewaction viewactionselected" : "viewswitchbtn weekaction viewaction"}
                            onClick={() => {
                                view != viewmatrix && (setview(viewmatrix));
                            }}>{Language.GetLanguageValue(props.culture, "Matrix")}</button></li>
                    </ul>
                </div>

            </div>
            <div className="ms-Grid-row plannerfilter">
                <div className="ms-Grid-col ms-sm12 ms-lg12">
                    {RenderTaskFilter()}
                </div>
            </div>
            { Renderdata }
        </div >
    )
};

export default PlannerDashboard;